import {
  About,
  Contact,
  Experience,
  Footer,
  Header,
  Nav,
  Portfolio,
  Services,
} from "./components";
import Whatsapp from "./components/Whatsapp/Whatsapp";

function App() {
  return (
    <>
      <Whatsapp />
      <Header />
      <Nav />
      <About />
      <Experience />
      <Services />
      <Portfolio />
      {/* <Testimonial /> */}
      <Contact />
      <Footer />
    </>
  );
}

export default App;
